/** Initial map data recipes, independent of application theme and classification palettes. */
export const DEFAULT_DATA_COLOURS = {
  point: '#E07A6A',
  line: '#0F4D3E',
  polygon: '#7FAE9E',
  outline: '#ffffff',
} as const;
